import { Image as ReactNativeImage, ImageProps } from "react-native"

export default ReactNativeImage

export type { ImageProps }
